import {isNumber, isString} from 'lodash';
import React, {Children, FC, isValidElement, PropsWithChildren, ReactNode, useMemo} from 'react';

/*
 * Props.
 */

export interface MutationProofTextProps {
  children: ReactNode;
}

/*
 * Component.
 */

/** Makes text safe for mutation by unfriendly Chrome extensions, such as dialers. */
export const MutationProofText: FC<PropsWithChildren<MutationProofTextProps>> = ({children}) => {
  const key = useMemo(() => collectText(children), [children]);

  // Key by the text itself so that the entire span is replaced when the text changes and we avoid any mutations to
  // the text node. Using a long string as a key should be fine, since strings are interned in JavaScript.
  return <span key={key}>{children}</span>;
};

/*
 * Helpers.
 */

export function collectText(children: ReactNode): string {
  const text = Children.map(children, (child) => {
    if (isValidElement(child)) {
      return collectText(child.props.children);
    }

    if (isNumber(child)) {
      return String(child);
    }

    if (isString(child)) {
      return child;
    }

    return '';
  });

  return (text ?? []).join('');
}
